// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","793":"component---src-pages-links-js"}[chunkId] + "-" + {"678":"bf031283d9ec3f588e4d","793":"6eaa5927fde78e22ce6b"}[chunkId] + ".js";
};